import React, { Fragment, useState }from 'react';
import Card from './Card';
import Filter from './Filter';
import Consolidated from './Consolidated';
import ConsolidatedUser from "./ConsolidatedUser";
import DataUser from "./DataUser";
import Table from "./Table";
import News from "./News";
import { PieChart } from "react-chartkick";
import "chart.js";
import './Content.css';

const Content = (props) => {
  const { app, render, setRender } = props;

  const [loading, setLoading] = useState(false);

  const elements = [
    { id: 1, name: "Cupones", full_path: "open_stats/coupons" },
    {
      id: 2,
      name: "Suscriptores Tiendas",
      full_path: "open_stats/subscribers",
    },
    { id: 3, name: "Tiendas Publicadas", full_path: "open_info/shops" },
    { id: 4, name: "Top 20", full_path: "open_stats/top_subscribers?top=true" },
    {
      id: 5,
      name: "Tiendas publicadas del",
      full_path: "open_stats/top_subscribers",
    },
  ];

  const [filterDates, setFilterDates] = useState({
    init_date: "",
    end_date: "",
  });

  const [dataCoupons, setDataCoupons] = useState({
    data: "",
    total: "",
  });

  const [dataSuscriptors, setDataSuscriptors] = useState({
    data: "",
    total: "",
  });
  const [dataShops, setDataShops] = useState({
    data: "",
    total: "",
  });
  const [dataTopShops, setDataTopShops] = useState({});
  const [totalTopShops, setTotalTopShops] = useState([]);

  const [dataConsolidated, setDataConsolidated] = useState([]);

  const [top, setTop] = useState([]);

  const [dataNews, setDataNews] = useState([]);

  const [dataUsers, setDataUsers] = useState({});

  const totals = (elm) => Object.values(elm).reduce((a, b) => a + b, 0);

  const search = (dates) => {
    const appName = app.name;

    setLoading(true);

    setFilterDates({
      ...filterDates,
      init_date: dates.init_date,
      end_date: dates.end_date,
    });

    // setRender();

    const isSingleApp =
      appName !== "Consolidado Cupones" &&
      appName !== "Tiendas Publicadas" &&
      appName !== "News Letter";

    if (isSingleApp) {
      searchSingleApp(dates);
    } else if (appName === "News Letter") {
      searchNewsLetter(dates);
    } else {
      searchConsolidated(dates, appName);
    }
  };

  const Loading = () => (
    <div className="card">
      <div className="card-body">
        <div className="card-title">
          <h3 className="loading">Cargando...</h3>
        </div>
      </div>
    </div>
  );

  const searchSingleApp = (dates) => {
    elements.map((e) => {
      return fetch(`${app.path}${e.full_path}`, {
        method: "POST",
        body: JSON.stringify(dates),
        headers: { "Content-Type": "application/json" },
      })
        .then((response) => response.json())
        .then((resolve) => {
          const record = e.name;

          if (record === "Cupones") {
            setDataCoupons({
              ...dataCoupons,
              data: resolve,
              total: totals(resolve),
            });
          } else if (record === "Suscriptores Tiendas") {
            setDataSuscriptors({
              ...dataSuscriptors,
              data: resolve,
              total: totals(resolve),
            });
          } else if (record === "Tiendas Publicadas") {
            setDataShops({
              ...dataShops,
              data: resolve,
              total: totals(resolve),
            });
          } else if (record === "Tiendas publicadas del") {
            setDataTopShops({
              ...dataTopShops,
              resolve,
            });
          } else if (record === "Top 20") {
            let records = [];
            let totalTop = [];
            resolve.map((elm) => {
              records.push([elm["name"], elm["total"]]);
              totalTop.push(elm["total"]);
              return null;
            });
            setTop(records);
            setTotalTopShops([totalTop.reduce((a, b) => a + b, 0)]);
          }

          setRender();
          setLoading(false);
        });
    });
  };

  const fetchData = (data, site, url) => {
    return fetch(url, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      mode: 'cors', // Explicitly set CORS mode
    })
      .then((response) => {
        console.log(`Response from ${url}:`, response);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((resolve) => {
        console.log(`Successful data from ${url}:`, resolve);
        return {
          site: site,
          data: resolve,
          total: totals(resolve),
        };
      })
      .catch((error) => {
        console.error(`Error fetching data from ${url}:`, error);
        // Return a default structure so the app doesn't break
        return {
          site: site,
          data: {},
          total: 0,
          error: error.message
        };
      });
  };

  const searchConsolidated = (dates, appName) => {
    const fullPath =
      appName === "Consolidado Cupones"
        ? "open_stats/coupons"
        : "open_info/shops";

    const promises = app.routes.map((site) => {
      const url = `${site["path"]}${fullPath}`;
      return fetchData(dates, site, url);
    });

    Promise.all(promises)
      .then((resolve) => {
        // Filter out failed requests (those with errors)
        const successfulResponses = resolve.filter(response => !response.error);
        setDataConsolidated(successfulResponses);
        requestUsers(dates, fullPath);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error in searchConsolidated:", error);
        setLoading(false);
        // Set empty data to prevent app crash
        setDataConsolidated([]);
      });
  };

  const searchNewsLetter = (data) => {
    const fullPath = "open_info/news_letter_subscriber";

    const promises = app.routes.map((elm) => {
      return fetch(`${elm["path"]}${fullPath}`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        mode: 'cors',
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((resolve) => {
          return {
            name: elm.name,
            data: resolve["app"],
            acum: resolve["total"],
          };
        })
        .catch((error) => {
          console.error(`Error fetching newsletter data from ${elm.path}:`, error);
          return {
            name: elm.name,
            data: {},
            acum: 0,
            error: error.message
          };
        });
    });

    Promise.all(promises)
      .then((results) => {
        const consolidated = results.filter(result => !result.error);
        setDataNews({
          ...dataNews,
          consolidated,
        });
        setRender();
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error in searchNewsLetter:", error);
        setLoading(false);
      });
  };

  const SingleApp = ({ dates }) => (
    <Fragment>
      <Card
        key={elements[0].id}
        name={elements[0].name}
        data={dataCoupons.data}
        total={dataCoupons.total}
      />
      <hr />
      <Card
        key={elements[1].id}
        name={elements[1].name}
        data={dataSuscriptors.data}
        total={dataSuscriptors.total}
      />
      <hr />
      <Card
        key={elements[2].id}
        name={elements[2].name}
        data={dataShops.data}
        total={dataShops.total}
      />
      <hr />
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            <h3>{elements[3].name}</h3>
          </div>
          {top ? <PieChart data={top} /> : <Loading />}
          <p>
            Total: <span>{totalTopShops}</span>
          </p>
        </div>
      </div>
      <hr />

      <div className="card">
        <div className="card-body">
          <div className="card-title">
            <h3>{`${elements[4].name} ${dates.init_date} al ${dates.end_date}`}</h3>
          </div>

          <Table data={dataTopShops.resolve} />
        </div>
      </div>
    </Fragment>
  );

  const requestUsers = (dates, url) => {
    // let recordsUsers = [];
    const resolves = app.routes.map((elm) => {
      return fetch(
        `${elm["path"]}${
          url === "open_stats/coupons"
            ? "open_stats/coupons_user"
            : "open_info/shops_user"
        }`,
        {
          method: "POST",
          body: JSON.stringify(dates),
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          mode: 'cors',
        }
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((resolve) => {
          return {
            name: elm.name,
            data: resolve,
          };
        })
        .catch((error) => {
          console.error(`Error fetching user data from ${elm.path}:`, error);
          return {
            name: elm.name,
            data: {},
            error: error.message
          };
        });
    });

    Promise.all(resolves)
      .then((resolve) => {
        let recordsUsers = resolve
          .filter(elm => !elm.error) // Filter out failed requests
          .map((elm) => {
            return { name: elm.name, data: elm.data };
          });

        setDataUsers({
          ...dataUsers,
          recordsUsers,
        });

        setRender();
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error in requestUsers:", error);
        setLoading(false);
      });
  };

  const isSingleApp =
    app.name !== "Consolidado Cupones" &&
    app.name !== "Tiendas Publicadas" &&
    app.name !== "News Letter";

  return (
    <div className="content">
      <div className="container-fluid">
        {app.name !== undefined ? (
          <>
            <h1 className="title">{app.name}</h1>
            <Filter onSearch={search} />
            <hr />
          </>
        ) : null}

        {loading ? <Loading /> : null}

        {!loading && render && isSingleApp ? (
          <SingleApp dates={filterDates} />
        ) : null}

        {!loading &&
        render &&
        (app.name === "Consolidado Cupones" ||
          app.name === "Tiendas Publicadas") ? (
          <>
            <Consolidated
              dataConsolidated={dataConsolidated}
              appName={app.name}
            />
            <hr />
            <ConsolidatedUser dataUsers={dataUsers} />
            <hr />
            <DataUser dataUsers={dataUsers} />
          </>
        ) : null}

        {!loading && render && app.name === "News Letter" ? (
          <News appName={app.name} data={dataNews} />
        ) : null}

        {!render && app.name === undefined ? (
          <div className="welcome-message">
            <h1>Bienvenido a TurboMaster</h1>
            <p>
              Seleciona la app del panel izquierdo y elije la fecha para la cual
              deseas realizar la consulta
            </p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Content;
